import { render, staticRenderFns } from "./picker-popup-base.mpx?vue&type=template&id=339e6e9c&isComponent&outputPath=components%2Fpicker-popup-base146a305a%2Findex"
import script from "./picker-popup-base.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Fpicker-popup-base146a305a%2Findex"
export * from "./picker-popup-base.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Fpicker-popup-base146a305a%2Findex"
import style0 from "./picker-popup-base.mpx?vue&type=style&index=0&id=339e6e9c&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_146a305a%22%7D&isComponent&outputPath=components%2Fpicker-popup-base146a305a%2Findex"


/* normalize component */
import normalizer from "!../../../../../example/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports